import { IconButton, useTheme } from "@mui/material";
import CallIcon from "@/assets/icons/lead-page/call-icon";
import CallPopoverButton from "@/modules/common/components/call-popover-button";
import useLeadContactMethods from "../../hooks/lead-info/lead-contact-methods.hook";

const ContactPhoneIcon = ({ phoneNumber }: { phoneNumber?: string }) => {
  const { isLoading } = useLeadContactMethods();
  const theme = useTheme();

  return (
    <CallPopoverButton phoneNumber={phoneNumber}>
      <IconButton
        data-testid="lead-call-button"
        disabled={isLoading}
        sx={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          backgroundColor: theme.nawy.colors.semantic.layer.accent,
          padding: "8px",
          "&:hover": { backgroundColor: theme.nawy.colors.primitives.navy[700] },
          "&.Mui-disabled": { backgroundColor: theme.nawy.colors.semantic.layer.accent, opacity: 0.5 },
        }}
      >
        <CallIcon fill="white" />
      </IconButton>
    </CallPopoverButton>
  );
};

export default ContactPhoneIcon;
